import React from 'react';
import setTitle from 'src/utils/setTitle';

const HelpCreateCases = () => {
  setTitle('ITSM | Help - Tickets');

  return (
    <>
      <h1>Create Tickets</h1>
      <p>
        A new ticket can be created by simply clicking the Create Ticket button.
        Let’s create a dummy ticket to see the complete process:
      </p>
      <ol>
        <li>
          After clicking Create Ticket, user will be prompted to select the
          Project where ticket needs to be created
          <img
            src="/static/help/createcase1.png"
            alt="Create ticket first step"
            style={{ marginTop: 15 }}
          />
        </li>
        {
          // TODO change picture
        }
        <li>
          Next step is to select the Ticket Type for the request
          <img
            src="/static/help/createcase2.png"
            alt=""
            style={{ marginTop: 15 }}
          />
        </li>
        <li>
          Add a Title to summarise your ticket and add a Description to explain
          your ticket in detail. Users can also add images or documents as
          attachments to include any additional information regarding the ticket
          <img src="/static/help/createcase3.png" alt="" />
        </li>
        <li>
          Review your ticket information and click on Create Ticket to complete the
          process.
          <img src="/static/help/createcase4.png" alt="" />
        </li>
      </ol>
    </>
  );
};

export default HelpCreateCases;
